import React, { useState } from 'react';
import Header from '../Header';

const RaiseTicket = () => {
  const [isSubmitting, setIsSubmitting] = useState(false); // for handling submit button
  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(null);

  const id = localStorage.getItem('userId'); // Get the userId from localStorage

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); 

    const form = e.target;
    const formData = new FormData(form);
    formData.append('user_id', id);

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/generateticket', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setSuccessMessage('Raise a Ticket successfully!');
        form.reset(); 
      } else {
        const errorData = await response.json();
        alert(`Failed to submit the ticket: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      setError(error.message); 
        setSuccessMessage(null);
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <>
      <Header />

      <div className="container mt-5">
      {error && <div className="alert alert-danger">{error}</div>}
      {successMessage && <div className="alert alert-success">{successMessage}</div>}
        <div className="card shadow">
          <div className="card-header">
            <h2>Raise Ticket</h2>
          </div>
          
        
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group mb-3">
                <input type="hidden" id="user_id" name="user_id" className="form-control" value={id} readOnly />                
              </div>

              <div className="form-group mb-3">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="Subject" name="Subject" className="form-control" required />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="description">Description</label>
                <textarea id="Description" name="Description" className="form-control" rows="4" required />
              </div>

              <div className="form-group mb-3">
                <label htmlFor="attachment">Attachment</label>
                <input type="file" id="file" name="file" className="form-control" />
              </div>

              <center>
                <button type="submit" className="btn btn-primary" disabled={isSubmitting} >
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
              </center>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RaiseTicket;
